import { createRoutine } from 'redux-saga-routines';

export const createPortfolio = createRoutine('@CREATE_EDIT_PORTFOLIO/CREATE');
